import { View, Text, ScrollView, Pressable } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import { Row, Table } from 'react-native-table-component'
import transl from '../translations/transl'
import AsyncStorage from '@react-native-async-storage/async-storage';
import dr from './../datosReferenciales.json'
import { useNavigation } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import GlobalStyles from './../style';

let lang = undefined;
let typeSort = 0;

const InGameStats = ({ route }) => {
	const navigation = useNavigation();
    useLayoutEffect(() => {
      navigation.setOptions({
          //headerShown: false,
          headerTitle: transl('Roster.estadisticas', lang)
      })
    }, []);

	const forceUpdate = useForceUpdate();
  
	lang = dr.idiomas[useSelector((state) => state.language)].value

	let state = { 
		tableHead: [
			returnPressable(transl('Statistics.n', lang),0),
			returnPressable(transl('Statistics.pos', lang),1),
			returnPressable(transl('Statistics.nombre', lang),2),
			returnPressable(transl('Statistics.goles', lang),3),
			returnPressable(transl('Statistics.tiros', lang),4),
			returnPressable(transl('Statistics.rebotesD', lang),5),
			returnPressable(transl('Statistics.rebotesO', lang),6),
			returnPressable(transl('Statistics.regates', lang),7),
			returnPressable(transl('Statistics.faltas', lang),8),
			returnPressable(transl('Statistics.expulsiones', lang),9),
			returnPressable(transl('Statistics.snitchs', lang),10),
			returnPressable(transl('Statistics.paradas', lang),11),
			returnPressable(transl('Statistics.golesEncajados', lang),12),
			returnPressable(transl('Statistics.asistencias', lang),13),
			returnPressable(transl('Statistics.balonesP', lang),14),
			returnPressable(transl('Statistics.balonesR', lang),15),
			returnPressable(transl('Statistics.bludgersL', lang),16),
			returnPressable(transl('Statistics.bludgersG', lang),17),
			returnPressable(transl('Statistics.bludgersD', lang),18),
			returnPressable(transl('Statistics.progresiones', lang),19),
			returnPressable(transl('Statistics.minutos', lang),20),
			returnPressable(transl('Statistics.edad', lang),21),
			returnPressable(transl('Statistics.semanasLesionado', lang),22)],
		widthArr: [30, 120, 160, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80]
	}

	return (
		<View>
			<View>
				<ScrollView horizontal={true}>
				<View>
					<Table borderStyle={{borderWidth: 1, borderColor: '#C1C0B9'}}>
						<Row data={state.tableHead} widthArr={state.widthArr} style={styles.header} textStyle={styles.text}/>
					</Table>
					<ScrollView>
						<Table>
						{
							displayStats(route.params)
						}
						</Table>
					</ScrollView>
				</View>
				</ScrollView>
			</View>
		</View>
	)

	function displayStats(teams) {
		const tableData = [];
    	const players = [
			...(teams[0]?.players ?? []),
			...(teams[1]?.players ?? [])
		];
		  

		for (let i = 0; i < players.length; i++) {
			const rowData = [];
			rowData.push(i+1)

			if (i%7 == 0) rowData.push("Guardian")
			else if (i%7 == 1 || i%7 == 2) rowData.push("Golpeador")
			else if (i%7 == 3 || i%7 == 4) rowData.push("Cazador")
			else if (i%7 == 5) rowData.push("Cazador Delantero")
			else if (i%7 == 6) rowData.push("Buscador")
			
			if ((i > 6 && i < 14) || (i > 20 && i < 28)) rowData[1] = rowData[1].concat(" (Supl.)");
	  
			rowData.push(players[i].name)
			rowData.push(players[i].inGameStats.goals)
			rowData.push(players[i].inGameStats.throws)
			rowData.push(players[i].inGameStats.defensiveRebounds)
			rowData.push(players[i].inGameStats.offensiveRebounds)
			rowData.push(players[i].inGameStats.dribbles)
			rowData.push(players[i].inGameStats.faults)
			rowData.push(players[i].inGameStats.expulsions)
			rowData.push(players[i].inGameStats.snitchs)
			rowData.push(players[i].inGameStats.saves)
			rowData.push(players[i].inGameStats.concededGoals)
			rowData.push(players[i].inGameStats.assists)
			rowData.push(players[i].inGameStats.bLost)
			rowData.push(players[i].inGameStats.bStolen)
			rowData.push(players[i].inGameStats.bludgersThrown)
			rowData.push(players[i].inGameStats.bludgersHit)
			rowData.push(players[i].inGameStats.bludgersSaves)
			rowData.push(players[i].inGameStats.progressions)
			rowData.push(players[i].inGameStats.jugadas)
			rowData.push(players[i].age)
			rowData.push(players[i].injury)
			
			tableData.push(rowData);
		}

		sortData(typeSort,tableData);

		return tableData.map((rowData, index) => (
			<Row
				key={index}
				data={rowData}
				widthArr={state.widthArr}
				textStyle={{textAlign:'center'}}
				style={[
					(rowData[0]<15 && !(index%2)) && {backgroundColor: '#cce6ff'},
					(rowData[0]<15 && index%2) && {backgroundColor: '#99ccff'},
					(rowData[0]>=15 && !(index%2)) && {backgroundColor: '#ffcccc'},
					(rowData[0]>=15 && index%2) && {backgroundColor: '#ff6666'},
					{paddingVertical:6}
				]}
			/>
		))
	}

	function sortData(type,tableData) {
		tableData.sort(function(a, b) {
		  if(type==0) return (a[0]) - (b[0])
		  if(type==1) return (a[1].localeCompare(b[1]))
		  else if(type==-1) return (b[1].localeCompare(a[1]))
		  if(type > 0) return (b[type]) - (a[type]);
		  else return (a[-type]) - (b[-type])
		});
	  }

	function returnPressable(text,toSort) {
		return <Pressable
					style={GlobalStyles.buttonTable}
					onPress={() => {
						if(toSort == typeSort) typeSort = -typeSort
						else typeSort = toSort
						forceUpdate()
					}
					}>
					<Text style={GlobalStyles.textForButtonTable}>{text}</Text>
				</Pressable>
	}
}

function useForceUpdate(){
	const [value, setValue] = useState(0);
	return () => setValue(value => value + 1);
  }

const styles = {
    container: { flex: 1, padding: 16, paddingTop: 30, backgroundColor: '#fff' },
    header: { height: 50, backgroundColor: '#e6e6e6' },
    text: { textAlign: 'center', fontWeight: 'bold', fontSize:13 },
    row: { height: 40, backgroundColor: '#E7E6E1' }
};

export default InGameStats